var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNumpy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 274,
    viewBox: "0 0 256 274",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M191.548 186.292L191.607 246.812L137.903 273.611V213.118L191.548 186.292ZM256.001 153.947V214.678L210.196 237.538L210.163 177.084L256.001 153.947ZM191.468 105.286L191.528 165.172L137.903 191.819V131.914L191.468 105.286ZM256.001 73.2054V132.714L210.15 156.023L210.11 96.0185L256.001 73.2054ZM129.739 66.1652L177.672 90.3598L127.941 115.335L80.9134 91.715L129.739 66.1652ZM63.0648 32.5108L108.784 55.5883L59.8455 81.1315L12.8906 57.5516L63.0648 32.5108ZM193.756 32.8611L242.998 57.5516L198.958 79.6706L150.926 55.4428L193.756 32.8611ZM128.232 0L172.562 22.2247L130.056 44.9188L84.3773 21.881L128.232 0Z",
    fill: "#4DABCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.944 131.914L82.7709 113.728V192.334C82.7709 192.334 38.533 98.2065 34.4344 89.7515C33.9056 88.6608 31.7307 87.4643 31.1754 87.1734C23.2428 83.0088 0 71.2354 0 71.2354V210.11L32.1538 227.298V154.707C32.1538 154.707 75.9224 238.813 76.3653 239.732C76.8082 240.651 81.2042 249.516 85.8977 252.629C92.1513 256.768 118.951 272.884 118.951 272.884L118.944 131.914Z",
    fill: "#4D77CF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 274,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumpy);
export default __webpack_public_path__ + "static/media/numpy.91d932cae04e8ca5d460a5213eaadfbd.svg";
export { ForwardRef as ReactComponent };